import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const AttendancePeriodSelector = ({ selectedPeriod, onPeriodChange, totalEmployees }) => {
  // Generate period options dynamically (last 24 months + next 3 months)
  const generatePeriodOptions = () => {
    const options = [];
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); // 0-11
    
    // Start from 24 months ago
    const startDate = new Date(currentYear, currentMonth - 23, 1);
    // End at 3 months in the future
    const endDate = new Date(currentYear, currentMonth + 3, 1);
    
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    let date = new Date(startDate);
    while (date <= endDate) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const value = `${year}-${String(month + 1).padStart(2, '0')}`;
      const label = `${monthNames[month]} ${year}`;
      
      options.push({ value, label });
      date.setMonth(date.getMonth() + 1);
    }
    
    return options.reverse();
  };

  const periodOptions = generatePeriodOptions();

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6 shadow-sm">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        {/* Period Selection */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Calendar" size={20} className="text-primary" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">Attendance Period</h2>
              <p className="text-sm text-muted-foreground">Select report period</p>
            </div>
          </div>
          
          <Select
            options={periodOptions}
            value={selectedPeriod}
            onChange={onPeriodChange}
            placeholder="Select period"
            className="w-48"
          />
        </div>

        {/* Employee Count Status Badge */}
        <div className="flex items-center gap-3 bg-muted/50 px-4 py-2 rounded-lg border border-border">
          <Icon name="Users" size={18} className="text-muted-foreground" />
          <span className="text-sm font-medium text-foreground">
            Active Workforce: <span className="text-primary font-bold">{totalEmployees || 0}</span> employees
          </span>
        </div>
      </div>
    </div>
  );
};

export default AttendancePeriodSelector;
